<div class="avatar-box">
	<!-- <div class="avatar"></div>
	<div class="indicator" *ngIf="!notificationData.readStatus" (click)="toggleReadStatus()"></div> -->
</div>
<div class="message-box" [ngClass]="{'resolved-alert': projectAlert.resolvedTime}">
	<!-- <div class="nf-message" [innerHtml]="statusMessage"></div> -->
	<div class="nf-message" [innerHtml]="statusMessage"></div>
	<!-- <span class="project-class" (click)="openProjectWindow(projectAlert.projectId)"
		*ngIf="showProject">{{projectAlert.project?.name}}</span> -->

	<div class="nf-time">{{timeToShow}}</div>
</div>
